import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_returns_hub_ComponentContextService } from './FootprintManager.returns_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_return_orders_gridComponent } from './FootprintManager.return_orders_grid.component';
import { FootprintManager_return_shipping_containers_gridComponent } from './FootprintManager.return_shipping_containers_grid.component';
import { Locations_warehouses_dd_multiComponent } from './Locations.warehouses_dd_multi.component'
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Returns_order_statuses_dd_multiComponent } from './Returns.order_statuses_dd_multi.component'
import { Returns_order_classes_dd_multiComponent } from './Returns.order_classes_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_return_orders_gridComponent),
    forwardRef(() => FootprintManager_return_shipping_containers_gridComponent),
    forwardRef(() => Locations_warehouses_dd_multiComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Returns_order_statuses_dd_multiComponent),
    forwardRef(() => Returns_order_classes_dd_multiComponent),
  ],
  selector: 'FootprintManager-returns_hub',
  templateUrl: './FootprintManager.returns_hub.component.html'
})
export class FootprintManager_returns_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    warehouses: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    owner: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    order_statuses: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    order_classes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    reference: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    input_scan: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create: new ToolModel(new SplitButtonModel<{ create_rma_order: ButtonModel, create_blind_return: ButtonModel }>(
        'create',
        new ButtonStyles(['creation'], null),
        false,
        false,
        'New',
        'icon-ic_fluent_add_20_regular',
        null,
        [
          new ButtonModel('create_rma_order', new ButtonStyles(null, null), false, false, false, 'RMA order', ''),
          new ButtonModel('create_blind_return', new ButtonStyles(null, null), false, false, false, 'Blind return', '')
        ])
    , false)
  };

  actionbar = {
  };

 filters = {
    warehouses: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouses'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', false, false),
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Owner', false, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', false, false),
    order_statuses: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['order_statuses'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
    order_classes: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['order_classes'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Order class', false, false),
    reference: new FieldModel(new TextBoxModel(this.formGroup.controls['reference'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Reference', false, false),
    input_scan: new FieldModel(new TextBoxModel(this.formGroup.controls['input_scan'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Scan container to begin blind receiving', false, false),
  };


  filtersets = {
    filters: new FieldsetModel(
      'Filters',
      false,
      true,
      false,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    Scan: new FieldsetModel(
      '',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      orders: new TabItemModel(
        this.rootTabGroup, 
        'Orders', 
        false,
        ),
      shipping_containers: new TabItemModel(
        this.rootTabGroup, 
        'Containers', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_orders_return_orders_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_orders_return_orders_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_orders_return_orders_grid_inParams_warehouseIds: number[];
    get $tabs_orders_return_orders_grid_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_warehouseIds;
    }
  
    cacheValueFor_$tabs_orders_return_orders_grid_inParams_statusIds: number[];
    get $tabs_orders_return_orders_grid_inParams_statusIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.order_statuses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_statusIds, expr)) {
        this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_statusIds = expr;
      }
      return this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_statusIds;
    }
  
    cacheValueFor_$tabs_orders_return_orders_grid_inParams_orderClassIds: number[];
    get $tabs_orders_return_orders_grid_inParams_orderClassIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.order_classes.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_orderClassIds, expr)) {
        this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_orderClassIds = expr;
      }
      return this.cacheValueFor_$tabs_orders_return_orders_grid_inParams_orderClassIds;
    }
  
    get $tabs_orders_return_orders_grid_inParams_reference(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.reference.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_warehouseIds: number[];
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_warehouseIds;
    }
  
    cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderStatusIds: number[];
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_orderStatusIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.order_statuses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderStatusIds, expr)) {
        this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderStatusIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderStatusIds;
    }
  
    cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderClassIds: number[];
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_orderClassIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.order_classes.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderClassIds, expr)) {
        this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderClassIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_containers_return_shipping_containers_grid_inParams_orderClassIds;
    }
  
    get $tabs_shipping_containers_return_shipping_containers_grid_inParams_reference(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.reference.control.value;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_orders', { read: FootprintManager_return_orders_gridComponent }) $tabs_orders: FootprintManager_return_orders_gridComponent;
      @ViewChild('$tabs_shipping_containers', { read: FootprintManager_return_shipping_containers_gridComponent }) $tabs_shipping_containers: FootprintManager_return_shipping_containers_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  cacheValueFor_$fields_order_statuses_selector_inParams_statusIds: number[];
  get $fields_order_statuses_selector_inParams_statusIds(): number[] {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = [1,2,4,8];
    
    if(!isEqual(this.cacheValueFor_$fields_order_statuses_selector_inParams_statusIds, expr)) {
      this.cacheValueFor_$fields_order_statuses_selector_inParams_statusIds = expr;
    }
    return this.cacheValueFor_$fields_order_statuses_selector_inParams_statusIds;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Returns hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Receive returned inventory and record the condition of returned items.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_returns_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.orders,
      this.tabs.shipping_containers,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Returns hub';
    
    const $hub = this;
    const $utils = this.$utils;

    (this.filters.order_statuses.control as SelectBoxModel).reset([1,2]);
    
    

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
    this.formGroup
      .controls['input_scan']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_input_scan_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_orders') {
      if (!isNil(this.$tabs_orders) && !this.tabs.orders.hidden) {
        this.$tabs_orders.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_shipping_containers') {
      if (!isNil(this.$tabs_shipping_containers) && !this.tabs.shipping_containers.hidden) {
        this.$tabs_shipping_containers.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Navigation_Inbound_Returns.isAuthorized()) {
      
      $hub.close();
      throw new Error ('This screen currently requires authorization, please see your system admin for access.')
    
  }
  
  
  if ((await $operations.FootprintManager.Enable_Locations_DefaultWarehouseByActivity.isAuthorized())) {
  
      let username = (await $flows.Utilities.get_username_flow({})).userName;
  
      let defaultWarehouseResult = (await $datasources.Locations.ds_get_default_warehouse_by_user.get({ userName: username })).result;
  
      $hub.filters.warehouses.control.value = $utils.isDefined(defaultWarehouseResult?.warehouseId) ? [defaultWarehouseResult.warehouseId] : null;
  }
  
  if ((await $operations.FootprintManager.Disable_ReturnOrders_OrderCreation.isAuthorized())){
      $hub.toolbar.create.hidden = true;
  }
  }
  on_create_rma_order_clicked(event = null) {
    return this.on_create_rma_order_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_rma_order_clickedInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try {
      // Get outbound shipment(s)
      let orderIds = (await $shell.FootprintManager.openoutbound_orders_eligible_for_return_gridDialog({ warehouseIds: $hub.filters.warehouses.control.value, ownerId: $hub.filters.owner.control.value, projectId: $hub.filters.project.control.value }, "modal", EModalSize.Large)).orderIds;
  
      if ($utils.isDefined(orderIds)) {
          let inboundOrderIds: number[] = [];
          let failedOrders: { orderId: number, reason: string }[] = [];
  
          for (let orderId of orderIds) {
              // Create RMA order(s)
              let result = (await $flows.Returns.create_return_order_from_outbound_flow({
                  outboundOrderId: orderId
              }));
  
              if ($utils.isDefined(result.reasons)) {
                  failedOrders.push({ orderId: orderId, reason: (await $flows.Utilities.grammar_format_string_array_flow({ values: result.reasons })).formattedValue });
              }
              else {
                  inboundOrderIds.push(result.inboundOrderId);
              }
          }
  
          $hub.refresh();
  
          if ($utils.isDefined(failedOrders)) {
              await $shell.FootprintManager.openErrorDialog(`Error creating RMA order`, null, inboundOrderIds.map(id => `Successfully created RMA for order ${id}`), 'Errors', failedOrders.map(o => ({ message: `Order ${o.orderId}`, detail: o.reason })));
          }
          else {
              await $shell.FootprintManager.openInfoDialog(`Successfully created RMA order`, inboundOrderIds.map(id => `Successfully created RMA for order ${id}`).join(', '));
          }
  
          if (orderIds.length === 1 && inboundOrderIds.length === 1) {
              $shell.FootprintManager.openreturn_order_editor({ orderId: inboundOrderIds[0]});
          }
      }
  }
  catch (error) {
      while ($utils.isDefined(error.error)) {
          error = error.error;
      }
  
      await $shell.FootprintManager.openErrorDialog('Error creating RMA order', error.message);
  }
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $hub.filters.project.control.value = null;
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($hub.filters.project.control.value) && !$utils.isDefined($hub.filters.owner.control.value)) {
      let project = (await $datasources.Materials.ds_get_project_by_projectId.get({ projectId: $hub.filters.project.control.value })).result[0];
  
      if ($utils.isDefined(project)) {
          $hub.filters.owner.control.value = project.OwnerId;
      }
  }
  }
  on_input_scan_change(event = null) {
    return this.on_input_scan_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_input_scan_changeInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try {
      if ($utils.isDefinedTrimmed($hub.filters.input_scan.control.value)) {
          let shippingContainer = (await $datasources.Returns.ds_get_shipping_container_by_shippingContainerCode.get({ shippingContainerCode: $hub.filters.input_scan.control.value.trim()})).result;
  
          if (!$utils.isDefined(shippingContainer)) { throw new Error(`Shipping container '${$hub.filters.input_scan.control.value.trim()}' does not exist or is not eligible for blind receiving.`); }
  
          $shell.FootprintManager.openblind_return_shipping_container_hub({ shippingContainerId: shippingContainer.Id });
      }
  }
  catch (error) {
      while ($utils.isDefined(error.error)) {
          error = error.error;
      }
  
      await $shell.FootprintManager.openErrorDialog('Error for scanned shipping container', error.message);
  }
  
  $hub.filters.input_scan.control.value = null;
  }
  on_create_blind_return_clicked(event = null) {
    return this.on_create_blind_return_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_blind_return_clickedInternal(
    $hub: FootprintManager_returns_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_returns_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  // Initialize the first warehouse selected
  var warehouseId = null;
  
  if ($utils.isDefined($hub.filters.warehouses.control.value)) {
      warehouseId = $hub.filters.warehouses.control.value[0];
  };
  
  
  
  const dialogResult = (await $shell.FootprintManager.openreturn_order_creation_form({
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value,
      warehouseId: $utils.isDefined(warehouseId) ? warehouseId : null
  }));
  
  
  
  }
  //#endregion private flows
}
